export default from '../NewPageView/NewPageView';